import { render, staticRenderFns } from "./MainViewVX.vue?vue&type=template&id=03d62e60"
import script from "./MainViewVX.vue?vue&type=script&lang=js"
export * from "./MainViewVX.vue?vue&type=script&lang=js"
import style0 from "./MainViewVX.vue?vue&type=style&index=0&id=03d62e60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports